module.exports = __webpack_public_path__ + "img/list-ol.20c2b0ee.svg";